import { defineStore } from 'pinia'

const REPLACE_DELAY = 50

// Only what can be serialised: the component is resolved from the modal registry by
// `type` where the modal renders, and callbacks stay with the modal service.
export const useModalStore = defineStore('modal', {
    state: () => ({
        isOpen: false,
        modalType: null,
        modalData: {},
    }),
    getters: {
        currentModal: state => ({
            type: state.modalType,
            data: state.modalData,
        }),
    },
    actions: {
        showModal({ type, data = {} }) {
            this.isOpen = true
            this.modalType = type
            this.modalData = data
        },
        hideModal() {
            this.isOpen = false
            this.modalType = null
            this.modalData = {}
        },
        replaceModal({ type, data }) {
            this.hideModal()
            setTimeout(() => this.showModal({ type, data }), REPLACE_DELAY)
        },
        updateModalData(data) {
            this.modalData = { ...this.modalData, ...data }
        },
    },
})
